import { FleekError } from './FleekError';

type Site = {
  id?: string;
  slug?: string;
};

type SiteNotDeployedErrorOptions = {
  site: Site;
};

export class SiteNotDeployedError extends FleekError<SiteNotDeployedErrorOptions> {
  public name = 'SiteNotDeployedError';

  toString = () => {
    if (this.data.site.slug) {
      return `Site ${this.data.site.slug} does not have released deployments.`;
    }

    return `Site does not have released deployments.`;
  };
}
